import React from "react";
import { connect } from "react-redux";
import { AuthHeader } from "../../components/Auth/AuthHeader";
import MainHeader from "../../components/MainHeader";
import { Redirect, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const PrivacyPolicy = ({ user }) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  
  document.title = "magikk - políticas de privacidade";

  return (
    <div className="bg-bodyBg">
      {user ? <MainHeader /> : <AuthHeader />}
      <div
        style={{
          maxWidth: "1000px",
          margin: "auto",
          marginTop: 100,
          alignContent: "center",
          alignItems: "center",
          backgroundColor: "#FFF",
          borderRadius: 40,
          padding: 70,
        }}
      ><>
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLVumN3ATOVc2BoeDKcwJhFTljiSzuFEcjsip7pjNdcnF);ol.lst-kix_list_1-3{list-style-type:none}ol.lst-kix_list_1-4{list-style-type:none}ol.lst-kix_list_1-5{list-style-type:none}ol.lst-kix_list_1-6{list-style-type:none}ol.lst-kix_list_1-0{list-style-type:none}.lst-kix_list_1-4>li{counter-increment:lst-ctn-kix_list_1-4}ol.lst-kix_list_1-1{list-style-type:none}ol.lst-kix_list_1-2{list-style-type:none}ol.lst-kix_list_1-6.start{counter-reset:lst-ctn-kix_list_1-6 0}.lst-kix_list_1-1>li{counter-increment:lst-ctn-kix_list_1-1}ol.lst-kix_list_1-3.start{counter-reset:lst-ctn-kix_list_1-3 0}ol.lst-kix_list_1-2.start{counter-reset:lst-ctn-kix_list_1-2 0}ol.lst-kix_list_1-8.start{counter-reset:lst-ctn-kix_list_1-8 0}.lst-kix_list_1-0>li:before{content:"(" counter(lst-ctn-kix_list_1-0,lower-roman) ") "}ol.lst-kix_list_1-5.start{counter-reset:lst-ctn-kix_list_1-5 0}ol.lst-kix_list_1-7{list-style-type:none}.lst-kix_list_1-1>li:before{content:"" counter(lst-ctn-kix_list_1-1,lower-latin) ". "}.lst-kix_list_1-2>li:before{content:"" counter(lst-ctn-kix_list_1-2,lower-roman) ". "}.lst-kix_list_1-7>li{counter-increment:lst-ctn-kix_list_1-7}ol.lst-kix_list_1-8{list-style-type:none}.lst-kix_list_1-3>li:before{content:"" counter(lst-ctn-kix_list_1-3,decimal) ". "}.lst-kix_list_1-4>li:before{content:"" counter(lst-ctn-kix_list_1-4,lower-latin) ". "}ol.lst-kix_list_1-0.start{counter-reset:lst-ctn-kix_list_1-0 0}.lst-kix_list_1-0>li{counter-increment:lst-ctn-kix_list_1-0}.lst-kix_list_1-6>li{counter-increment:lst-ctn-kix_list_1-6}.lst-kix_list_1-7>li:before{content:"" counter(lst-ctn-kix_list_1-7,lower-latin) ". "}.lst-kix_list_1-3>li{counter-increment:lst-ctn-kix_list_1-3}.lst-kix_list_1-5>li:before{content:"" counter(lst-ctn-kix_list_1-5,lower-roman) ". "}.lst-kix_list_1-6>li:before{content:"" counter(lst-ctn-kix_list_1-6,decimal) ". "}ol.lst-kix_list_1-7.start{counter-reset:lst-ctn-kix_list_1-7 0}.lst-kix_list_1-2>li{counter-increment:lst-ctn-kix_list_1-2}.lst-kix_list_1-5>li{counter-increment:lst-ctn-kix_list_1-5}.lst-kix_list_1-8>li{counter-increment:lst-ctn-kix_list_1-8}ol.lst-kix_list_1-4.start{counter-reset:lst-ctn-kix_list_1-4 0}.lst-kix_list_1-8>li:before{content:"" counter(lst-ctn-kix_list_1-8,lower-roman) ". "}ol.lst-kix_list_1-1.start{counter-reset:lst-ctn-kix_list_1-1 0}ol{margin:0;padding:0}table td,table th{padding:0}.c30{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#f2f2f2;border-left-style:solid;border-bottom-width:1pt;width:254.8pt;border-top-color:#000000;border-bottom-style:solid}.c2{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#3b3838;border-left-style:solid;border-bottom-width:1pt;width:141.6pt;border-top-color:#000000;border-bottom-style:solid}.c15{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#f2f2f2;border-left-style:solid;border-bottom-width:1pt;width:169.8pt;border-top-color:#000000;border-bottom-style:solid}.c50{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#000000;border-left-style:solid;border-bottom-width:1pt;width:254.8pt;border-top-color:#000000;border-bottom-style:solid}.c1{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:middle;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#f2f2f2;border-left-style:solid;border-bottom-width:1pt;width:141.6pt;border-top-color:#000000;border-bottom-style:solid}.c29{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:1pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:1pt;border-top-style:solid;background-color:#000000;border-left-style:solid;border-bottom-width:1pt;width:424.7pt;border-top-color:#000000;border-bottom-style:solid}.c47{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:0pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:260pt;border-top-color:#000000;border-bottom-style:solid}.c45{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:0pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:129.8pt;border-top-color:#000000;border-bottom-style:solid}.c44{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:0pt;width:92pt;border-top-color:#000000;border-bottom-style:solid}.c41{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:0pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:92pt;border-top-color:#000000;border-bottom-style:solid}.c25{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:0pt;width:129.8pt;border-top-color:#000000;border-bottom-style:solid}.c42{border-right-style:solid;padding:0pt 5.4pt 0pt 5.4pt;border-bottom-color:#000000;border-top-width:1pt;border-right-width:0pt;border-left-color:#000000;vertical-align:top;border-right-color:#000000;border-left-width:0pt;border-top-style:solid;border-left-style:solid;border-bottom-width:0pt;width:260pt;border-top-color:#000000;border-bottom-style:solid}.c4{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c9{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:9pt;font-family:"Calibri";font-style:normal}.c14{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:10pt;font-family:"Times New Roman";font-style:normal}.c12{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c10{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c31{color:#ff0000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c13{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:7pt;font-family:"Times New Roman";font-style:normal}.c28{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c5{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c33{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:center}.c32{color:#ffffff;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c3{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c18{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c0{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:justify}.c48{font-weight:400;text-decoration:none;vertical-align:baseline;font-family:"Calibri";font-style:normal}.c43{font-weight:400;vertical-align:baseline;font-size:11pt;font-family:"Calibri";font-style:normal}.c46{text-decoration:none;vertical-align:baseline;font-size:20pt;font-family:"Calibri";font-style:normal}.c16{margin-left:-5.4pt;border-spacing:0;border-collapse:collapse;margin-right:auto}.c40{padding-top:0pt;padding-bottom:0pt;line-height:1.15;text-align:left}.c21{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c24{text-decoration-skip-ink:none;-webkit-text-decoration-skip:none;text-decoration:underline}.c36{background-color:#ffffff;max-width:481.9pt;padding:56.7pt 56.7pt 56.7pt 56.7pt}.c27{margin-left:35.5pt;margin-right:70.8pt}.c37{color:inherit;text-decoration:inherit}.c19{border:1px solid black;margin:5px}.c6{color:#000000;font-weight:700}.c23{height:0pt}.c17{background-color:#ffffff}.c7{height:11pt}.c35{color:#1155cc}.c22{color:#000000}.c11{font-weight:700}.c38{color:#ff0000}.c39{margin-left:46.1pt}.c26{margin-left:35.4pt}.c20{font-size:9pt}.c49{height:19.3pt}.c34{color:#0563c1}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:11pt;font-family:"Calibri"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:12pt;color:#000000;font-weight:700;font-size:13pt;padding-bottom:3pt;font-family:"Cambria";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#000000;font-weight:700;font-size:13pt;padding-bottom:3pt;font-family:"Calibri";line-height:1.1500000000000001;font-style:italic;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}'
        }}
      />
      <hr style={{ pageBreakBefore: "always", display: "none" }} />
      <p className="c3 c7">
        <span className="c46 c6" />
      </p>
      <p className="c18">
        <span className="c6 c46">Política de Privacidade</span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span className="c10">Olá! Seja bem-vinda(o)!</span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span>
          Esta plataforma e todo o seu conteúdo (“Plataforma”) é de responsabilidade
          e operada pela MAGIKK SERVICOS DE INFORMACOES NA INTERNET LTDA, sociedade
          empresária limitada, inscrita no CNPJ sob nº 35.352.544/0001-05, com sede
          na Avenida das Américas, nº 8585, loja SS0216, Barra da Tijuca, Rio de
          Janeiro/RJ, CEP 22.793-081, com o e-mail de contato{" "}
        </span>
        <span>falacomigo@magikk.com</span>
        <span className="c38">&nbsp;</span>
        <span>(“</span>
        <span className="c11">magikk</span>
        <span className="c10">” ou “Nós”).</span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span>A </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;é a solução para comunicar e engajar a responsabilidade
          socioambiental com seus colaboradores e consumidores. Facilitamos
          encontrar sua causa e recompensamos boas práticas através de uma moeda
          social, o “
        </span>
        <span className="c11">karma</span>
        <span className="c10">”.</span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span className="c10">
          Nossos clientes possuem a vantagem de trabalhar com pessoas comprometidas
          a incentivar o bem de uma forma leve e efetiva. Somos comprometidos a
          ajudar nossos clientes a alcançar o sucesso no cumprimento dos prazos e
          metas de seus projetos, mediante a integração de princípios e práticas de
          desenvolvimento socioambiental.{" "}
        </span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span>
          Para tanto, Nós (i) divulgamos e comercializamos cursos, workshops e
          eventos promovidos ou que contam com a participação da{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;e seus membros; bem como (ii) oferecemos conteúdos de qualidade
          sobre boas ações e práticas de desenvolvimento socioambiental
          (“Serviços”).
        </span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span className="c10">
          Assim, no âmbito da prestação de nossos Serviços, podemos utilizar alguns
          dados capazes de identificar ou tornar identificáveis as pessoas físicas
          (“Dados Pessoais”) que navegam em nosso Site (“Visitantes”) ou que
          utilizam os nossos Serviços (Usuário: “Voluntários”, “Organizações não
          governamentais – ONG” e “Parceiros”).{" "}
        </span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span>
          Nesse contexto, como a sua privacidade é muito importante para Nós, esta
          Política de Privacidade (“Política de Privacidade”) tem como objetivo
          informar a você, seja Visitante ou Usuário (“Você” ou “Usuário”), sobre
          como a{" "}
        </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;trata os seus Dados Pessoais, ou seja, como os seus Dados Pessoais
          são coletados, usados, compartilhadas com terceiros, armazenados e
          protegidos pela{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          , bem como a forma como Você pode realizar o controle de seus Dados
          Pessoais.
        </span>
      </p>
      <p className="c18 c7">
        <span className="c10" />
      </p>
      <p className="c18">
        <span>
          O CONHECIMENTO E CIÊNCIA DESSA POLÍTICA DE PRIVACIDADE É INDISPENSÁVEL
          PARA QUE VOCÊ POSSA ACESSAR O NOSSO SITE, CADASTRAR-SE EM NOSSAS
          PLATAFORMAS E USUFRUIR OS NOSSOS SERVIÇOS
        </span>
        <span className="c11">
          . CASO VOCÊ NÃO CONCORDE COM OS TERMOS DESSA POLÍTICA DE PRIVACIDADE, POR
          FAVOR, NÃO ACESSE O SITE, NÃO CONTINUE O SEU PROCEDIMENTO DE CADASTRO E
          NÃO ADQUIRA OU UTILIZE NOSSOS SERVIÇOS.
        </span>
        <span className="c10">
          &nbsp;NESSE CASO, PEDIMOS QUE, POR GENTILEZA, NOS INFORME O MOTIVO DA
          DISCORDÂNCIA ATRAVÉS DO E-MAIL falacomigo@magikk.com, PARA QUE POSSAMOS
          APRIMORAR NOSSOS SERVIÇOS.
        </span>
      </p>
      <hr style={{ pageBreakBefore: "always", display: "none" }} />
      <p className="c3 c7">
        <span className="c10" />
      </p>
      <p className="c3">
        <span className="c4">
          1)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QUAIS OS DADOS PESSOAIS
          NÓS COLETAMOS SOBRE VOCÊ?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c5">
        <span className="c10">A </span>
        <span className="c4">magikk</span>
        <span className="c10">
          &nbsp;somente coletará Dados Pessoais dos Usuários que naveguem em nosso
          Site ou que utilizem os nossos Serviços. Nós coletamos o mínimo possível
          de Dados Pessoais necessários para alcançar as finalidades para as quais
          esses mesmos dados foram coletados, conforme informado na tabela abaixo.{" "}
        </span>
      </p>
      <p className="c5">
        <span className="c10">
          Nós utilizamos esses Dados Pessoais apenas para a finalidade específica
          correlacionada na tabela, valendo-se da base(s) legal(is)
          pré-determinada(s) para tanto.
        </span>
      </p>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr>
      <th style={{ border: "1px solid #ddd", backgroundColor: "#3b3838", padding: "8px" }}>Finalidade</th>
      <th style={{ border: "1px solid #ddd", backgroundColor: "#3b3838", padding: "8px" }}>Dados Pessoais</th>
      <th style={{ border: "1px solid #ddd", backgroundColor: "#3b3838", padding: "8px" }}>Base Legal</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>Contato (Atendimento ao cliente)</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Dados de Contato: nome completo, e-mail, telefone, endereços (logradouro, número, complemento, bairro, cidade, Estado, país e CEP)
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>Consentimento</td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Acesso ao Site (Analytics)
        <br />
        (para verificar suas atividades em nosso Site e Plataforma a fim de identificar seu padrão de navegação para entender como podemos melhorar nossos Serviços)
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Cookies
        <br />
        Dados de navegação: IP, data e hora de acesso, localização geográfica, duração da visita, páginas visitadas, tipo e versão de navegador
        <br />
        Dados do dispositivo: Tipo e versão do sistema operacional
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Obrigação legal (para os endereços IP quando usados para cumprir com o Marco Civil da Internet)
        <br />
        Legítimo interesse (para os demais dados e finalidades)
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Contratação da Plataforma da magikk
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Dados cadastrais: Nome completo, e-mail, telefone, data de nascimento, login, senha, endereço (residencial), CPF, profissão (opcional), formação (opcional) e rede social (opcional).
        <br />
        Dados de Pagamento: Dados de cartão de crédito, conta bancária, CPF
        <br />
        Dados das transações: Data da compra, valores, serviço adquirido
        <br />
        Envio de correspondência: Nome e sobrenome, endereço
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>Execução do Contrato</td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Contratação dos Serviços
        <br />
        (para contratação de cursos, workshops, projetos, eventos e restituições)
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Dados cadastrais: Nome completo, e-mail, telefone, data de nascimento, login, senha, endereço (residencial), CPF, profissão (opcional), formação (opcional) e rede social (opcional).
        <br />
        Dados de cobrança: endereço de cobrança, CPF
        <br />
        Dados das transações: Data da compra, valores, serviço adquirido
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Execução de contrato (para os dados essenciais)
        <br />
        Consentimento (para os dados opcionais)
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Marketing
        <br />
        (para comunicar as novidades da magikk)
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Dados de Contato: Nome e sobrenome, e-mail, telefone, serviço contratado
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Consentimento (para novos contatos para finalidade de prospecção)
        <br />
        Legítimo interesse (para usuários com quem já há uma relação para finalidade informativa)
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Newsletter
        <br />
        (para enviar conteúdo relacionado à boas ações e educação socioambiental)
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Dados de Contato: Nome e sobrenome, e-mail
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>Consentimento</td>
    </tr>
  </tbody>
</table>

      <p className="c5 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">A </span>
        <span className="c4">magikk</span>
        <span className="c10">
          &nbsp;somente irá coletar Dados Pessoais de Você, se as finalidades
          descritas acima não puderem ser alcançadas por outros meios que não
          necessitem da coleta de tais Dados Pessoais.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          2)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COM QUEM NÓS
          COMPARTILHAMOS OS SEUS DADOS PESSOAIS?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>Todas as informações coletadas pela </span>
        <span className="c11">magikk</span>
        <span className="c10">&nbsp;sobre Você são confidenciais. </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Em hipótese alguma nós venderemos as suas informações. No entanto, podemos
          compartilhá-las com terceiros, inclusive seus Dados Pessoais, caso seja
          necessário para:
        </span>
      </p>
      <p className="c3 c7">
        <span className="c10" />
      </p>
      <p className="c0 c27">
        <span className="c6 c20">Prestação de nossos Serviços</span>
        <span className="c9">
          &nbsp;– seus Dados Pessoais podem ser compartilhados com alguns de nossos
          parceiros e fornecedores, a fim de viabilizarmos a prestação dos Nossos
          Serviços a Você.
        </span>
      </p>
      <p className="c0 c27 c7">
        <span className="c38 c20 c48" />
      </p>
      <p className="c0 c27">
        <span className="c6 c20">Acesso ao Site</span>
        <span className="c9">
          &nbsp;– seus Dados Pessoais podem ser compartilhados com alguns de nossos
          parceiros e fornecedores de serviços de web analytics, para possibilitar
          que Você acesse o Site sem problemas e para que Nós, a partir de uma
          avaliação das suas interações com o Site, possamos compreender como
          melhorar nossos Serviços e a sua experiência no acesso ao Site.
        </span>
      </p>
      <p className="c0 c27 c7">
        <span className="c9" />
      </p>
      <p className="c0 c27">
        <span className="c6 c20">Resguardo de direito</span>
        <span className="c22 c20">s – a </span>
        <span className="c6 c20">magikk</span>
        <span className="c9">
          &nbsp;poderá compartilhar seus Dados Pessoais com terceiros, caso seja
          necessário para resguardar os nossos direitos e interesses, cumprir uma
          obrigação legal relacionada aos seus negócios ou atender a uma ordem
          judicial (por exemplo, com escritórios de advocacia, escritórios de
          contabilidade, Poder Judiciário, Ministério Público, Órgãos de Defesa do
          Consumidor, autoridades da Administração Pública, entre outros).
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          As empresas a qual compartilhamos os seus Dados Pessoais são:
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c26">
        <span>(i) a AWS que pode ser contatada por meio do </span>
        <span className="c24 c35">
          <a className="c37" href="mailto:resolution@amazon.com">
            resolution@amazon.com
          </a>
        </span>
        <span>&nbsp;</span>
        <span className="c10">;</span>
      </p>
      <p className="c0 c26">
        <span>(ii) a Google Drive que pode ser contatada por meio do </span>
        <span className="c24 c35">
          <a className="c37" href="mailto:support-in@google.com">
            support-in@google.com
          </a>
        </span>
        <span className="c10">&nbsp;;</span>
      </p>
      <p className="c0 c26">
        <span>(iii) a Asana que pode ser contatada por meio do </span>
        <span className="c24 c35">
          <a className="c37" href="mailto:support@asana.com">
            support@asana.com
          </a>
        </span>
        <span className="c10">&nbsp;;</span>
      </p>
      <p className="c0 c26">
        <span>(iv) a ASAAS que pode ser contatada por meio do </span>
        <span className="c24 c35">
          <a className="c37" href="mailto:contato@asaas.com.br">
            contato@asaas.com.br
          </a>
        </span>
        <span className="c10">&nbsp;;</span>
      </p>
      <p className="c0 c26">
        <span>(v) Melhor Envio que pode ser contatada por meio do </span>
        <span className="c24 c34">
          <a className="c37" href="mailto:contato@contato.com">
            contato@melhorenvio.com
          </a>
        </span>
        <span>; </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c3 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Em todos os casos, os seus Dados Pessoais somente serão compartilhados com
          terceiros apenas para atender as finalidades aqui descritas e no estrito
          limite necessário para que tal finalidade seja atingida.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span className="c10">
          , sempre que possível, irá pseudonimizar os seus Dados Pessoais antes do
          compartilhamento e solicitará aos terceiros que mantenham a
          confidencialidade e segurança das informações compartilhadas.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COMO NÓS PROTEGEMOS OS
          SEUS DADOS PESSOAIS?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c10">
          Nós nos esforçamos para proteger a sua privacidade e os seus Dados
          Pessoais de acessos não autorizados, destruição, perda, alteração,
          comunicação, divulgação ou qualquer forma de tratamento inadequado ou
          ilícito. Para tanto, Nós adotamos medidas técnicas, administrativas e
          organizacionais de segurança.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>
          A fim de manter os seus Dados Pessoais seguros e evitar incidentes, Nós
          empregamos o uso de logins e senhas para acesso aos servidores onde estão
          armazenados os Dados Pessoais e armazenamos os logs de acesso a tais
          servidores para realizar o controle e manter atualizado o inventário de
          acesso aos Dados Pessoais. Também realizamos cópias de segurança dos dados
          periodicamente (backups) e utilizamos técnicas de criptografia. Todos os
          softwares, ferramentas e tecnologias adotadas pela{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;no tratamento de Dados Pessoais levam em consideração as práticas de
          mercado e contam com um nível razoável de atualização.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;leva a sério a segurança das suas informações. Todos os Dados
          Pessoais são confidenciais e o seu acesso por terceiros é restrito, sendo
          permitido apenas às pessoas previamente autorizadas (sejam as empresas com
          quem os compartilhamos ou nossos empregados e colaboradores), que estão
          obrigados ao dever absoluto sigilo não sendo permitido o seu uso de forma
          inadequada, em desacordo com o disposto nesta Política de Privacidade.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Você deve colaborar para manter a segurança de seus Dados Pessoais,
          assegurando que o ambiente de seu computador ou dispositivo de acesso ao
          Site permaneçam seguros, a partir (i) do uso de ferramentas adequadas,
          como, por exemplo, antivírus e firewall, (ii) da utilização de versões
          atualizadas de navegadores, sistemas operacionais e demais software
          aplicáveis, bem como (iii) do não compartilhamento de seu login e senha
          com terceiros.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;solicitará, por e-mail, telefone, Whatsapp, Instagram, Facebook ou
          Linkedin, informações relativas a suas senhas de acesso ou quaisquer
          informações pessoais a seu respeito. Caso Você suspeite que os seus Dados
          Pessoais estejam em risco, Você deve entrar em contato conosco.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          4)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QUAIS SÃO OS SEUS
          DIREITOS SOBRE OS DADOS PESSOAIS?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c10">
          Você possui alguns direitos inerentes a sua condição de titular dos Dados
          Pessoais. Esses direitos visam proteger os seus Dados Pessoais e
          resguardar a sua privacidade.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Listamos abaixo quais são esses direitos e como você pode exercê-los:
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr>
      <th style={{ border: "1px solid #ddd", backgroundColor: "#3b3838", padding: "8px" }} colSpan={2}>
        Direitos do Titular
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>existência e acesso</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de confirmar se Nós realizamos algum tratamento com seus Dados Pessoais, bem como ter acesso aos seus Dados Pessoais tratados por Nós, mediante a solicitação e o recebimento de um documento contendo a cópia integral de seus Dados Pessoais e o respectivo tratamento realizado com ele.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>retificação</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de solicitar a correção ou a atualização de seus Dados Pessoais, caso verifique que eles estão incorretos ou desatualizados.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>explicação</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de obter informações sobre o tratamento realizado por Nós com seus Dados Pessoais, como, por exemplo, quais Dados Pessoais seus são coletados, como eles são utilizados, com quem são compartilhados e por que, entre outras informações. Essa Política de Privacidade visa oferecer todas as informações necessárias para garantir que esse direito seja atendido. Caso Você não compreenda alguma questão aqui abordada, ou identifique a omissão de algum assunto, Você pode solicitar esclarecimentos à magikk.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px" , fontWeight: "bold"}}>cancelamento</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de solicitar a exclusão de seus Dados Pessoais da nossa base de dados, de forma definitiva, ou solicitar que eles sejam anonimizados ou, ainda, requerer que o tratamento dos seus Dados Pessoais pela magikk seja bloqueado. A magikk irá sempre atender a sua requisição, exceto com relação aos pedidos de exclusão e anonimização, quando a manutenção do Dado Pessoal for necessária para a magikk resguardar seus direitos e/ou cumprir obrigações legais. Você está ciente de que nos casos de exclusão, anonimização e bloqueio, Você poderá ficar impossibilitado de acessar determinados recursos oferecidos por Nós.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>oposição</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de contestar determinado tratamento de seus Dados Pessoais, bem como de retirar o seu consentimento que esteja atrelado à determinada finalidade de tratamento. Neste último caso, a magikk poderá continuar tratando o seu Dado Pessoal, caso o tratamento esteja amparado por outra base legal que não seja o consentimento. Em caso de contestação a magikk poderá demonstrar que trata os seus Dados Pessoais dentro da legalidade.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>portabilidade</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de solicitar que os Dados Pessoais armazenados pela magikk sobre Você lhe sejam enviados, ou enviados aos terceiros que Você indicar, em formato estruturado e interoperável.
      </td>
    </tr>
    <tr>
      <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>revisão de decisões automatizadas</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        Você tem o direito de solicitar a revisão de decisões que tenham afetado seus interesses e tenham sido tomadas a partir de um tratamento automatizado de seus Dados Pessoais. Embora essa prerrogativa esteja prevista na legislação, as decisões tomadas pela magikk não são automatizadas, de maneira que esse direito não é aplicável.
      </td>
    </tr>
  </tbody>
</table>

      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Além de exercer os direitos aqui descritos, Você pode escolher por não
          fornecer determinados Dados Pessoais para Nós (como, por exemplo, no caso
          de Cookies). No entanto, alguns desses dados são essenciais para a
          prestação dos Serviços e acesso ao Site, sem os quais Você está ciente de
          que não poderá não usar determinados recursos.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>
          Você poderá exercer qualquer um dos direitos aqui descritos, a qualquer
          momento, por procedimento gratuito e facilitado. Para tanto, basta
          encaminhar uma solicitação à{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;através do e-mail falacomigo@magikk.com. Nós empregaremos nossos
          melhores esforços para atender a todos os pedidos no menor espaço de tempo
          possível.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          5)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SEUS DADOS PESSOAIS
          PODEM SER TRANSFERIDOS PARA O EXTERIOR?
        </span>
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;armazena a sua base de dados em servidores de terceiros, contratados
          para esta finalidade, que podem estar localizados no exterior.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>Nesses casos, a </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;garante que os seus Dados Pessoais somente serão enviados para um
          país cuja Autoridade Nacional de Proteção de Dados considere ter um grau
          de proteção de dados pessoais adequado ou desde que todos os requisitos
          previstos na legislação brasileira aplicável relacionados a transferência
          internacional sejam cumpridos. á exercer qualquer um dos direitos aqui
          descritos, a qualquer momento, por procedimento gratuito e facilitado.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>Para tanto, basta encaminhar uma solicitação à </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;através do e-mail falacomigo@magikk.com. Nós empregaremos nossos
          melhores esforços para atender a todos os pedidos no menor espaço de tempo
          possível.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          6)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;POR QUANTO TEMPO OS
          DADOS PESSOAIS SÃO ARMAZENADOS?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>Todos os Dados Pessoais coletados pela </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;são armazenados pelo período necessário para atender as finalidades
          descritas nesta Política de Privacidade ou até que Você, como titular,
          exerça os seus direitos de oposição ou cancelamento, solicitando a
          exclusão do Dado Pessoal ou retirando o seu consentimento. Uma vez que os
          Dados Pessoais não sejam mais necessários ou relevantes para a finalidade
          específica ou que Você exerça, como titular, os direitos aqui mencionados,
          eles serão excluídos de nossa base de dados. Todavia, mesmo que a
          finalidade tenha sido concluída ou que Você tenha retirado seu
          consentimento ou solicitado a exclusão de seus Dados Pessoais, a{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;poderá mantê-los armazenados, se necessário para resguardar seus
          direitos, cumprir ordens judiciais ou requisições emanadas de autoridades
          competentes, bem como para cumprir de obrigações legais e regulatórias
          (como, por exemplo, para fins de prestação de contas, armazenamento do
          registro de acesso ao Site, etc.).
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c3">
        <span className="c4">
          7)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;POR QUE O NÓS COLETAMOS
          DADOS MEDIANTE COOKIES?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>
          Alguns Dados Pessoais são voluntariamente oferecidos por Você (como, por
          exemplo, dados de contato, dados cadastrais, dados de pagamento, dados de
          cobrança, etc.). No entanto, quando Você acessa do Site, outros Dados
          Pessoais podem ser coletados pela{" "}
        </span>
        <span className="c11">EMPRESA</span>
        <span className="c10">
          &nbsp;de forma automática, por meio de cookies e outras tecnologias de
          monitoramento assemelhadas (“Cookies”).{" "}
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c10">
          Cookies são pequenos arquivos que o Site envia para o seu navegador e são
          armazenados no seu dispositivo, permitindo a coleta de informações a seu
          respeito de maneira automática, como, por exemplo, seu idioma, sua
          recorrência de acesso ao Site, etc.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c4">Quais os tipos de cookies que utilizamos?</span>
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c22">A </span>
        <span className="c6">magikk </span>
        <span className="c22">
          utiliza tanto cookies primários quanto cookies de terceiros.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c22">
          Cookies primários são cookies emitidos pelo domínio da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c22">
          &nbsp;e geralmente são utilizados para identificar suas preferências para
          facilitar funcionalidades básicas da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">.</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c22">
          Cookies de terceiros pertencem e são administrados por outras empresas,
          tais com parceiros de negócios da{" "}
        </span>
        <span className="c6">magikk </span>
        <span className="c22">
          ou provedores de serviços. Estes cookies podem ser necessários para
          produzir certos formulários, como, por exemplo, permitir alguma propaganda
          fora da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">.</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c24 c22">Os nossos </span>
        <span className="c6 c24">COOKIES</span>
        <span className="c43 c24 c22">
          &nbsp;podem apresentar diferentes funções:
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies essenciais</span>
        <span className="c22">
          &nbsp;- Alguns cookies são essenciais para acessar a áreas específicas da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c22">. Permitem a navegação na </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">
          &nbsp;e a utilização das suas aplicações, tal como acessar áreas seguras
          do site através de login. Sem estes cookies, os serviços que o exijam não
          podem ser prestados.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies analíticos</span>
        <span className="c22">
          &nbsp;- Utilizamos estes cookies para analisar a forma como Você usa a{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">
          &nbsp;e monitorar a performance desta. Isto permite-nos fornecer uma
          experiência de alta qualidade ao personalizar a nossa oferta e rapidamente
          identificar e corrigir quaisquer problemas que surjam.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies de funcionalidade</span>
        <span className="c22">
          &nbsp;- Utilizamos cookies de funcionalidade para nos permitir relembrar
          as suas preferências. Assim, os cookies de funcionalidade guardam as
          preferências do usuário relativamente à utilização da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">
          , de forma que não seja necessário voltar a configurar o site cada vez que
          o visita.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies de publicidade</span>
        <span className="c10">
          &nbsp;- Servem para direcionar a publicidade em função dos interesses de
          cada Titular e do número de visitas que realizou, permitindo limitar o
          número de vezes da exibição do anúncio. Estes cookies ajudam a medir a
          eficácia da publicidade.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c24 c22">Os </span>
        <span className="c24 c6">COOKIES</span>
        <span className="c24 c22 c43">&nbsp;utilizados podem ser:</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies permanentes</span>
        <span className="c22">
          &nbsp;- Ficam armazenados ao nível do navegador de internet (browser) nos
          seus dispositivos de acesso (desktop, mobile e tablet) e são utilizados
          sempre que Você realize uma nova visita a{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">
          . Geralmente são utilizados para direcionar a navegação de acordo com os
          seus interesses, permitindo-nos prestar um serviço mais personalizado.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c6">Cookies de sessão</span>
        <span className="c22">
          &nbsp;- São temporários, permanecem nos cookies do seu navegador de
          internet (browser até sair da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">
          . A informação obtida permite identificar problemas e fornecer uma melhor
          experiência de navegação.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c22">Utilização de </span>
        <span className="c6">COOKIES</span>
        <span className="c10">:</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <table>
  <tbody>
    <tr>
      <td colSpan={1} rowSpan={1} style={{fontWeight: 'bold'}}>
        <p>Cookie</p>
      </td>
      <td colSpan={1} rowSpan={1} style={{fontWeight: 'bold'}}>
        <p>Função</p>
      </td>
      <td colSpan={1} rowSpan={1} style={{fontWeight: 'bold'}}>
        <p>Tempo para expirar</p>
      </td>
    </tr>
    <tr>
      <td colSpan={1} rowSpan={1}>
        <p>magikk_lgpd</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>Usado para ativação ou não da coleta de dados de navegação do Google Analytics.</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>Expira ao fechar o navegador</p>
      </td>
    </tr>
    <tr>
      <td colSpan={1} rowSpan={1}>
        <p>_ga</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>Usado pelo Google Analytics para distinguir usuários.</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>400 dias</p>
      </td>
    </tr>

    <tr>
      <td colSpan={1} rowSpan={1}>
        <p>fr, wd, xs, c_user, ps_n, sb, datr, ps_I</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>Gerados somente se o usuário realizar login via plataforma Facebook.</p>
      </td>
      <td colSpan={1} rowSpan={1}>
        <p>400 dias</p>
      </td>
    </tr>
  </tbody>
</table>


      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c4">Como Você pode rejeitar ou apagar cookies?</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          A maioria dos navegadores da Internet aceitam cookies, entretanto, os
          usuários podem configurar seus navegadores para recusar certos tipos de
          cookies ou cookies específicos. Além disso, os usuários podem apagar os
          cookies a qualquer momento
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Depois de autorizar o uso de cookies, Você pode sempre desativar parte ou
          a totalidade dos nossos cookies.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Todos os browsers permitem ao utilizador aceitar, recusar ou apagar
          cookies, nomeadamente através da seleção das definições apropriadas no
          respetivo navegador. Pode configurar os cookies no menu "opções" ou
          "preferências" do seu browser.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c22">
          Vale destacar que, ao desativar cookies, pode impedir que alguns serviços
          da{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c22">
          &nbsp;funcionem corretamente, afetando, parcial ou totalmente, a navegação
          na{" "}
        </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c10">.</span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c22">Por fim, ao utilizar a </span>
        <span className="c6">PLATAFORMA</span>
        <span className="c22">
          &nbsp;sem apagar ou rejeitar alguns ou todos os cookies, Você concorda que
          a{" "}
        </span>
        <span className="c6">magikk </span>
        <span className="c22">poderá realizar o </span>
        <span className="c6">TRATAMENTO DE DADOS </span>
        <span className="c22">e</span>
        <span className="c6">&nbsp;</span>
        <span className="c10">
          posicionar aqueles cookies que não apagados ou rejeitados nos seus
          respectivos dispositivos.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c3">
        <span className="c4">
          8)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QUANDO ESSA POLÍTICA DE
          PRIVACIDADE PODERÁ SER ALTERADA?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;constantemente implementa atualizações no Site e nos seus Serviços,
          de forma que tais atualizações podem refletir na forma como os seus Dados
          Pessoais são tratados. Assim, sempre que houver modificações no
          tratamento, essa Política de Privacidade poderá ser alterada. As
          alterações poderão ocorrer a qualquer tempo e quantas vezes forem
          necessárias.{" "}
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span className="c10">
          Por esse motivo, é importante que Você revise essa Política de Privacidade
          periodicamente para estar a par dessas modificações. No início dessa
          Política de Privacidade indicamos a data da última atualização.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>
          Sempre que houver uma atualização desta Política de Privacidade, a{" "}
        </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;empreenderá esforços razoáveis para tornar isso transparente. Caso a
          atualização seja relevante e possa impactar nos direitos do Usuário, sendo
          necessário um novo consentimento a respeito de determinado tratamento, a{" "}
        </span>
        <span className="c11">magikk</span>
        <span className="c10">
          &nbsp;fará uma solicitação diretamente à Você, caso Você seja um Usuários
          cadastrado.
        </span>
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span className="c4">
          9)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COMO ENTRAR EM CONTATO
          CONOSCO SOBRE O TRATAMENTO DE SEUS DADOS PESSOAIS?
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;está sempre à disposição para esclarecer questões relacionadas ao
          tratamento dos seus Dados Pessoais. Em caso de dúvidas, solicitações,
          problemas, reclamações ou sugestões relacionadas a esta Política de
          Privacidade, ao tratamento de seus Dados Pessoais ou o exercício de seus
          direitos como titular dos Dados Pessoais, Você deverá enviar um e-mail à{" "}
        </span>
        <span className="c11">magikk</span>
        <span>&nbsp;no seguinte endereço </span>
        <span className="c11">falacomigo@magikk.com</span>
        <span className="c10">. </span>
      </p>
      <p className="c0 c7">
        <span className="c10" />
      </p>
      <p className="c0">
        <span>A </span>
        <span className="c11">magikk</span>
        <span>
          &nbsp;empregará os melhores esforços para responder a todos os e-mails no
          menor espaço de tempo possível.
        </span>
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
      <p className="c3 c7">
        <span className="c4" />
      </p>
    </>
    </div>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivacyPolicy);
